import { useCallback, useState } from 'react'

export interface UseFailedImagesResult {
  hasFailed: (image?: string) => boolean
  markFailed: (image: string) => void
}

export const useFailedImages = (): UseFailedImagesResult => {
  const [failedImages, setFailedImages] = useState<string[]>([])

  const hasFailed = useCallback(
    (image?: string) => image !== undefined && failedImages.includes(image),
    [failedImages]
  )

  const markFailed = useCallback((image: string) => {
    setFailedImages((current) =>
      current.includes(image) ? current : [...current, image]
    )
  }, [])

  return { hasFailed, markFailed }
}
